import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-anchor-blue",
  "use": "icon-anchor-blue-usage",
  "viewBox": "0 0 9.8 10.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9.8 10.8\" id=\"icon-anchor-blue\"><path d=\"M4.9 10V0m4.6 6.4l-4.6 3.7L.3 6.4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol